import { showPendingToastIfAny as showPendingToastIfAnyBase } from '@mathflat/shared/@modules/forceUpdate/postUpdateToast'

import { toastSuccess } from '@/utils/toast'

export const showPendingToastIfAny = () => showPendingToastIfAnyBase(toastSuccess)
